export const TYPEFIXED = {
    registration: 'registrationFee',
    exam: 'examRegistrationFee',
    pro: 'zinkerzMarathon',
    nothing: 'nothing'
}

export default {TYPEFIXED}